/** Periodicidades das integrações */
export interface IntegrationPeriodicidade {
    id: number;
    nome: string;
}

export const periodicidadeDiaria: IntegrationPeriodicidade = {id: 1, nome: 'Diária'};
export const periodicidadeSemanal: IntegrationPeriodicidade = {id: 2, nome: 'Semanal'};
export const periodicidadeMensal: IntegrationPeriodicidade = {id: 3, nome: 'Mensal'};
export const periodicidadeAnual: IntegrationPeriodicidade = {id: 4, nome: 'Anual'};
export const periodicidadeGeral: IntegrationPeriodicidade = {id: 5, nome: 'Geral'};
export const periodicidadeIndividual: IntegrationPeriodicidade = {id: 6, nome: 'Individual'};


export const integracaoPeriodicidades: IntegrationPeriodicidade[] = [
    periodicidadeDiaria,
    periodicidadeSemanal,
    periodicidadeMensal,
    periodicidadeAnual,
    periodicidadeGeral,
    periodicidadeIndividual
];

/** Verifica se a periodicidade é Diária */
export function isPeriodicidadeDiaria(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeDiaria.id;
}

/** Verifica se a periodicidade é Semanal */
export function isPeriodicidadeSemanal(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeSemanal.id;
}

/** Verifica se a periodicidade é Mensal */
export function isPeriodicidadeMensal(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeMensal.id;
}

/** Verifica se a periodicidade é Anual */
export function isPeriodicidadeAnual(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeAnual.id;
}

/** Verifica se a periodicidade é Geral */
export function isPeriodicidadeGeral(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeGeral.id;
}

/** Verifica se a periodicidade é Individual */
export function isPeriodicidadeIndividual(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeIndividual.id;
}
